<template>
  <app-layout>
    <app-layout-content>
      <app-card>
        <app-toolbar column>
          <app-toolbar-content>
            <app-image
              src="images/icons/id-card.svg"
              width="180px"
              style="max-height:20vh"
            />

            <h2 v-if="title" v-html="title"></h2>

            <small v-if="description" v-html="description"></small>

            <app-form id="cpfForm" @submit="checkForm">
              <app-input-container required>
                <app-input
                  v-model="cpf"
                  ref="cpf"
                  autocomplete="disabled"
                  autofocus
                />
              </app-input-container>
            </app-form>
          </app-toolbar-content>
        </app-toolbar>
      </app-card>
    </app-layout-content>

    <app-layout-footer :fixed="false">
      <app-card style="padding-top:0">
        <app-buttons column>
          <app-button
            type="submit"
            form="cpfForm"
            :loading="isProcessing"
            :disabled="isProcessing"
            primary
            full-width
            >Atualizar meu CPF</app-button
          >

          <app-button @click="cancel" full-width :disabled="isProcessing"
            >Cancelar</app-button
          >
        </app-buttons>
      </app-card>
    </app-layout-footer>
  </app-layout>
</template>

<script>
import { validateCpf } from '@/helpers'

export default {
  name: 'UserRequestCpf',

  data() {
    return {
      isProcessing: false,
      cpf: undefined,
    }
  },

  computed: {
    isValidCpf() {
      return validateCpf(this.cpf)
    },
  },

  props: {
    value: {
      type: Boolean,
      required: false,
      default: true,
    },

    user: {
      type: Object,
      required: false,
      default() {
        return app.user
      },
    },

    title: {
      type: String,
      required: false,
      default: 'Informa aqui teu CPF...',
    },

    description: {
      type: String,
      required: false,
      default: 'É necessário informar o seu CPF para concluir esta operação...',
    },
  },

  methods: {
    cancel() {
      this.$emit('cancel')
    },

    async saveCpf({ cpf, user = this.user }) {
      const updatedUser = await app.editUser({
        cpf,
      })

      this.$emit('saved', updatedUser)
    },

    async checkForm(form) {
      const cpfInput = this.$refs.cpf

      try {
        this.isProcessing = form.disable = true

        const cpf = this.cpf

        if (!cpf)
          return await app.alert({
            title: 'Opss...',
            content: 'Digite o seu CPF!',
            onClose: cpfInput.focus,
          })

        if (!this.isValidCpf)
          return await app.alert({
            title: 'Opss...',
            content: 'O CPF informado não é válido!',
            onClose: cpfInput.select,
          })

        await this.saveCpf({ cpf })
      } catch (response) {
        switch (response?.code) {
          case 'CPF_IN_USE':
          case 'CPF_ALREADY_USED':
            await app.dialog({
              title: 'Opss...',
              content: `Este CPF já está sendo utilizado por outro usuário!`,
              buttons: [
                {
                  primary: true,
                  content: 'Alterar',
                  onClick: modal => {
                    modal.close()
                    cpfInput.select()
                  },
                },

                {
                  content: 'Fale conosco',
                  onClick: modal => {
                    this.cancel()
                    modal.close()
                    app.goToContact()
                  },
                },
              ],
            })
            break

          default:
            console.error(response)

            await app.alert({
              title: 'Opss...',
              content: 'Não conseguimos salvar o seu CPF!',
            })
            break
        }
      } finally {
        this.isProcessing = form.disable = false
      }
    },
  },
}
</script>
